import { Container } from '@mui/material';
import React from 'react'
import Menu from './component/Menu';

const DashboardMenu = (props) => {
    const menuList = [ // You can pass 4 perameters for menu title, link, target and customClass
    {
      title: "DAs",
      link: "",
    },            
    {
    title: "Home",
    link: "",
    },
       
    ];
  return (
    <Container maxWidth="xl">
        <Menu menuList={menuList} />
    </Container>
  )
}

export default DashboardMenu